import React from 'react';
import { SectionShell } from './SectionShell';
import { tensions } from '../data/caseStudy';
export function Tensions() {
  return <SectionShell number="03" title="Leading a rebrand at scale" tone="grey" eyebrow="Three tensions I had to navigate, none of which could be resolved by choosing a side." data-id="element-153" data-mp="35pnz7hs12to0">
      <div className="grid grid-cols-3 gap-8" data-id="element-154" data-mp="2vs058u28xq6w">
        {tensions.map((tension, index) => <article key={tension.title} className="border-t-2 border-ink pt-8" data-id="element-155" data-mp="2i1obyrtxdle6" data-mpi={index}>
            <p className="font-display text-sm font-semibold tabular-nums tracking-[0.2em] text-ink/40" data-id="element-156" data-mp="2hzk27t9chs5z">
              {`0${index + 1}`}
            </p>
            <h3 className="mt-6 font-display text-2xl font-semibold leading-tight tracking-tightest text-ink" data-id="element-157" data-mp="284jnglclxdu7">
              {tension.title}
            </h3>
            <p className="mt-5 text-[15px] leading-relaxed text-ink/70" data-id="element-158" data-mp="1z2sjbkxptf2g">{tension.body}</p>
          </article>)}
      </div>
    </SectionShell>;
}